import api from "../../../Services/api";

export const createForm = async (formData) => {
  try {
    const response = await api.post("/forms/create", formData);
    return response.data;
  } catch (error) {
    console.error("Error creating form:", error);
    throw error;
  }
};
